'use strict';

/**
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');

var template = require('modules/base/templates/layout/restriction-filter-modal.hbs');

var RestrictionModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },
});

module.exports = RestrictionModalView;